// extracted by mini-css-extract-plugin
export default {"header":"CabinGuaranteedList_header__ALVjo","table":"CabinGuaranteedList_table__kczuL","table-cell":"CabinGuaranteedList_table-cell__I6xRg"};